import React, { useEffect, useState } from 'react'
import { ErrorExplanation } from '../../components/ErrorExplanation/ErrorExplanation'
import { SubmitButton } from '../../components/SubmitButton/SubmitButton'
import { mutationLogin } from '../../api/mutations'
import { useForm } from 'react-hook-form'
import { useMutation } from '@tanstack/react-query'
import { Box, Paper, TextField, Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { ILogin } from '../../api/types/user'
import { AxiosResponse } from 'axios'
import { ErrorSpinner } from '../../components/ErrorSpinner/ErrorSpinner'
import { useApiErrors } from '../../hooks/useApiErrors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginForm: {
      marginTop: '5rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
    loginRow: {
      margin: '1rem',
    },
    button: {
      margin: theme.spacing(0.5),
    },
    textCenter: {
      textAlign: 'center',
    },
  })
)

export const Login = () => {
  const { apiErrors, setApiErrors } = useApiErrors()
  const { register, handleSubmit, errors } = useForm<ILogin>()
  const classes = useStyles()
  const [showLoginForm, setShowLoginForm] = useState(false)

  useEffect(() => {
    if (localStorage.access) {
      window.location.href = '/'
    } else {
      setShowLoginForm(true)
    }
  }, [])

  const onLoginFailed = (error: any) => {
    setApiErrors([
      (error.response && error.response.data && error.response.data.message) || 'Login failed',
    ])
    delete localStorage.csrf
    delete localStorage.access
  }

  const onLoginSuccess = (response: AxiosResponse) => {
    localStorage.csrf = response.data.csrf
    localStorage.access = response.data.access
    localStorage.refresh = response.data.refresh
    setApiErrors([])
    window.location.href = '/'
  }

  const { mutate: loginMutation, isLoading: isMutating } = useMutation(
    (creds: ILogin) => mutationLogin(creds),
    {
      onError: resp => {
        onLoginFailed(resp)
      },
      onSuccess: resp => {
        if (!resp.data.csrf) {
          onLoginFailed(resp)
        } else {
          onLoginSuccess(resp)
        }
      },
    }
  )
  const onSubmit = (data: ILogin) => loginMutation(data)

  return (
    <>
      <Box display="flex" justifyContent="center">
        <Paper className={classes.loginForm} elevation={3}>
          {!showLoginForm && <ErrorSpinner />}
          {showLoginForm && (
            <>
              <Box className={classes.loginRow}>
                <Typography variant="h4">Log In</Typography>
              </Box>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box className={classes.loginRow}>
                  <ErrorExplanation errors={apiErrors} />
                </Box>
                <Box className={classes.loginRow}>
                  <TextField
                    name="username"
                    label="Username"
                    variant="outlined"
                    fullWidth={true}
                    inputProps={{
                      ref: register({
                        required: 'Required',
                      }),
                    }}
                    error={!!errors.username}
                    helperText={errors.username && errors.username.message}
                  />
                </Box>
                <Box className={classes.loginRow}>
                  <TextField
                    type="password"
                    name="password"
                    label="Password"
                    variant="outlined"
                    fullWidth={true}
                    inputProps={{
                      ref: register({
                        required: 'Required',
                      }),
                    }}
                    error={!!errors.password}
                    helperText={errors.password && errors.password.message}
                  />
                </Box>

                <Box className={classes.loginRow}>
                  <SubmitButton disabled={isMutating}>Login</SubmitButton>
                </Box>
              </form>
            </>
          )}
        </Paper>
      </Box>
    </>
  )
}
